import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'

import { Icon } from 'components'
import styles from './ActionsNav.scss';

class ActionsNav extends Component {


  render() {
    
  	let classNames = styles.actionsNav;

  	if(this.props.inModal){
  		classNames = classNames + ' ' + styles.inModal;
  	}

    return (
      <nav className={classNames}>
        {this.props.children}
      </nav>
    )
  }
}


export default ActionsNav;



// WEBPACK FOOTER //
// ./src/components/molecules/ActionsNav/index.js